import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import VueResource from  'vue-resource'
import VueSession from 'vue-session'
import LayoutBlank from '@/layout/LayoutBlank'
import adminRoutes from './administration'
import homeRoutes from './home'
import businessRoutes from './business'
import dataLeadRoutes from './datalead'
import empresasRoutes from './empresasFiltroBasico'
import uploadsRoutes from './upload'
import mappointRoutes from './mappoint'
import consumoRoutes from './consumo'
import apiRoutes from './apidados'
import purchaseflowRoutes from './purchaseflow'
import inicioRoute from './dashboard'
import comprarDados from './comprardados'
import comprarDadosColunas from './escolhercolunas'
import resumoCompra from './resumoCompra'
import messagesRoutes from './messages'

const ROUTES = [
  // Default route
  {
    path: '',
    component: LayoutBlank,
    children: [{
      path: '',
      component: () => import('@/components/authentication/Login')
    }]
  }]
  .concat(homeRoutes)
  .concat(adminRoutes)
  .concat(businessRoutes)
  .concat(dataLeadRoutes)
  .concat(empresasRoutes)
  .concat(mappointRoutes)
  .concat(uploadsRoutes)
  .concat(purchaseflowRoutes)
  .concat(consumoRoutes)
  .concat(apiRoutes)
  .concat(inicioRoute)
  .concat(comprarDados)
  .concat(comprarDadosColunas)
  .concat(resumoCompra)
  .concat(messagesRoutes)


Vue.use(VueSession)
Vue.use(Router)
Vue.use(Meta)
Vue.use(VueResource);

const router = new Router({
  base: '/foundation/',
  mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }
})

router.beforeEach((to, from, next) => {
  if (!Vue.prototype.$session.exists() && to.path !== '/') {
    next('/');
  } else {
    next();
  }
  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
